export const employeeTranslations = {
  en: {
    nav: {
      employees: "Employees",
      time: "My time",
      clock: "Clock",
      assignments: "Assignments",
    },
    weekdays: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
    },
    employees: {
      title: "Employees",
      currentPassword: "Current password",
      changeEmail: "Change email address",
      newEmail: "New email address",
      requestEmailChange: "Request email change",
      emailChangeSent: "Confirmation email sent.",
      languageHelp: "Choose the language used for your employee portal.",
      newChangeRequest: "New change request",
      changeRequestHelp:
        "Submit profile, email or offboarding changes for management approval.",
      requestType: "Request type",
      offboardingDate: "Offboarding date",
      offboardNow: "End employment now",
      submitChangeRequest: "Submit request",
      changeRequestHistory: "Change request history",
      noChangeRequests: "No change requests yet.",
      calendarFeedHelp:
        "Create a private iCalendar feed for your permitted project events and company holidays.",
      createCalendarFeed: "Create calendar feed",
      rotateCalendarFeed: "Rotate calendar feed",
      revokeCalendarFeed: "Revoke calendar feed",
      calendarFeedUrl: "Calendar feed URL",
      pendingChangeRequests: "Pending employee change requests",
      approveChange: "Approve",
      rejectChange: "Reject",
      decisionNote: "Decision note",
      ahvPlaceholder: "e.g. 756.1234.5678.97",
      myData: "My data",
      security: "Security",
      language: "Language",
      changeRequests: "Change requests",
      calendarFeed: "Calendar feed",
      actions: "Management actions",
      bankName: "Bank name",
      bankIban: "IBAN",
      employmentEndEnabled: "Employment end date enabled",
      noEmploymentEnd: "No employment end date",
      subtitle: "People, employment details, time balances and employee files.",
      search: "Search employees",
      empty: "No employees found.",
      overview: "Overview",
      timeBalances: "Time & balances",
      employmentProfile: "Employment profile",
      editProfile: "Edit employment profile",
      employeeNumber: "Employee number",
      jobTitle: "Job title",
      pensum: "Pensum",
      phone: "Phone",
      dateOfBirth: "Date of birth",
      nationality: "Nationality",
      ahvNumber: "AHV / AVS number",
      employmentStart: "Employment start",
      employmentEnd: "Employment end",
      address: "Address",
      addressLine1: "Address line 1",
      addressLine2: "Address line 2",
      postalCode: "Postal code",
      city: "City",
      country: "Country",
      weeklySchedule: "Weekly schedule",
      minutesHelp: "Planned minutes per day. 504 minutes = 8 h 24 min.",
      balances: "Vacation & compensation",
      vacationUsed: "Vacation used",
      vacationRemaining: "Vacation remaining",
      compensationEarned: "Compensation earned",
      compensationRemaining: "Compensation remaining",
      vacationGranted: "Vacation granted (minutes)",
      vacationWeeksOverride: "Vacation weeks override",
      vacationAdjustment: "Vacation adjustment (minutes)",
      compensationAdjustment: "Compensation adjustment (minutes)",
      changePassword: "Change password",
      lifecycle: "Employee lifecycle",
      deactivatedHelp:
        "The account is deactivated. Historical work, documents and payroll remain available.",
      reactivate: "Reactivate employee",
      offboardingReason: "Reason",
      offboard: "Offboard employee",
      offboardConfirm:
        "Deactivate this employee account while preserving all historical records?",
      requestKind: {
        profile: "Profile change",
        email: "Email change",
        offboard: "Offboarding",
      },
      requestStatus: {
        pending: "Pending",
        verified: "Verified",
        approved: "Approved",
        rejected: "Rejected",
        cancelled: "Cancelled",
      },
    },
    documents: {
      title: "Documents",
      upload: "Upload document",
      chooseFile: "Choose file",
      empty: "No documents yet.",
      deleteConfirm: "Delete this document?",
      newUpload: "New document",
      category: "Category",
      visibility: "Visibility",
      employeeVisible: "Employee can see",
      managementOnly: "Management only",
    },
    time: {
      myTime: "My time",
      subtitle:
        "Record attendance, absences and allocate working time to projects.",
      clock: "Clock in and out",
      clockDescription: "Record today's attendance with one clear action.",
      assignments: "Time assignments",
      assignmentsDescription:
        "Assign worked time to projects and record absences.",
      clockedInSince: "Clocked in since {{time}}",
      noOpenSession: "No active attendance session.",
      todayStamped: "Stamped today",
      dailyGoalDifference: "Difference to daily goal",
      todaySessions: "Today's clock sessions",
      dailyGoal: "Daily goal: {{value}}",
      inProgress: "In progress",
      noSessionsToday: "No clock sessions today.",
      assignmentMatrix: "Assignment matrix",
      assignmentMatrixDescription:
        "Assign project time directly across a day, week or month.",
      editAllocationCell: "Edit {{project}} on {{date}}",
      viewDay: "Day",
      viewWeek: "Week",
      viewMonth: "Month",
      previousPeriod: "Previous period",
      nextPeriod: "Next period",
      available: "Available",
      noEligibleProjects: "No eligible projects.",
      team: "Team time",
      teamSubtitle:
        "Review attendance, absences, project allocation and weekly approvals.",
      weekOf: "Week of",
      stamp: "Live time clock",
      clockIn: "Clock in",
      clockOut: "Clock out",
      lunch: "Lunch",
      planned: "Planned",
      worked: "Worked",
      projectTime: "Project time",
      weekBalance: "Week balance",
      rejected: "Rejected",
      week: "Week",
      ofPlanned: "of {{value}} planned",
      entries: "Attendance & absences",
      addEntry: "Add entry",
      allocations: "Project allocations",
      allocate: "Allocate project time",
      submitWeek: "Submit week",
      unallocated: "Unallocated project time",
      validation: "Validation",
      issues: "issues",
      complete: "Complete",
      submit: "Submit for approval",
      type: "Type",
      start: "Start",
      end: "End",
      minutes: "Minutes",
      project: "Project",
      deleteEntryConfirm: "Delete this time entry?",
      deleteAllocationConfirm: "Delete this allocation?",
      approve: "Approve",
      reject: "Reject",
      rejectReason: "Reason for rejection",
      reopen: "Reopen",
      reopenConfirm: "Reopen this approved timesheet?",
      holidays: "Company holidays",
      holidayName: "Holiday name",
      paid: "Paid",
      unpaid: "unpaid",
      status: {
        draft: "Draft",
        submitted: "Submitted",
        approved: "Approved",
        rejected: "Rejected",
      },
      kind: {
        attendance: "Attendance",
        break: "Break",
        vacation: "Vacation",
        sick: "Sickness",
        military: "Military service",
        accident: "Accident",
        compensation_leave: "Compensation leave",
        unpaid_leave: "Unpaid leave",
        other_absence: "Other absence",
      },
      workflow: {
        worked: "Worked",
        previousWeek: "Previous week",
        nextWeek: "Next week",
        clockState: "Clock status",
        clockedIn: "Clocked in",
        clockedOut: "Clocked out",
        todaySummary: "Today’s summary",
        weekNotCurrent: "Select the current week to use the live clock.",
        break: "Break",
        paidBreak: "Paid break",
        unpaidBreak: "Unpaid break",
        absence: "Absence",
        remaining: "Remaining",
        details: "Details",
        actions: "Actions",
        noEntries: "No attendance or absence entries.",
        noAllocations: "No project allocations.",
        noNotes: "No notes",
        editEntry: "Edit time entry",
        newEntry: "New time entry",
        allocateTitle: "Allocate working time",
        searchProjects: "Search eligible projects",
        remainingByDay: "Remaining time by day",
        allocateRemaining: "Allocate remaining today",
        allocateRemainingWeek: "Allocate remaining for week",
        breaksPaidNotice: "Breaks are paid. Breaks do not reduce worked time.",
        issueCount: "{{count}} issues",
        noIssues: "No incomplete items. This week is ready for submission.",
        approval: {
          draft: "Draft — not submitted",
          submitted: "Submitted for approval",
          approved: "Approved",
          rejected: "Rejected — make the requested changes and resubmit",
        },
        issue: {
          open_stamp: "Clock out before submitting the timesheet.",
          missing_day: "No work or absence is recorded.",
          allocation_mismatch:
            "Allocate all worked time ({{worked}} minutes worked, {{allocated}} allocated).",
          vacation_overdrawn: "Vacation bookings exceed the available balance.",
          unknown: "Complete the required time information.",
        },
        errors: {
          generic: "The time change could not be saved. Please try again.",
          conflict: "The time sheet changed. Reload the week and try again.",
          forbidden: "You cannot change this time information.",
          validation: "Review the time fields and correct the invalid values.",
        },
        breakPresetMorning: "Morning break · 09:00",
        breakPresetLunch: "Lunch break · 12:00",
        breakPresetAfternoon: "Afternoon break · 15:00",
      },
      teamManagement: {
        search: "Search employees",
        searchPlaceholder: "Name or email",
        statusFilter: "Timesheet status",
        allStatuses: "All statuses",
        previousWeek: "Previous week",
        nextWeek: "Next week",
        holidaySummary: "Company holidays this week",
        paidHoliday: "Paid",
        unpaidHoliday: "Unpaid",
        dayBreakdown: "Daily breakdown",
        attendance: "Attendance",
        breaks: "Breaks",
        netAttendance: "Net attendance",
        allocated: "Allocated",
        absences: "Absences",
        projects: "Projects",
        noProjects: "No projects allocated.",
        noDays: "No time entries for this week.",
        noTimesheet: "No timesheet",
        actions: "Actions",
        rejectionReason: "Rejection reason",
        rejectDialogTitle: "Reject {{name}}’s timesheet",
        rejectReasonHint:
          "Explain what needs to be corrected before resubmitting.",
        rejectReasonRequired: "A rejection reason is required.",
        empty: "No employees match these filters.",
      },
    },
    payroll: {
      title: "Payroll",
      actions: "Actions",
      statements: "Payroll statements",
      certificates: "Salary certificates",
      salarySettings: "Salary settings",
      expenses: "Expenses",
      expensesTitle: "Expense claims",
      expensesDescription:
        "Create, submit and review expense claims and attach receipts.",
      expensesEmployeeDescription:
        "Submit travel, meal and other reimbursable expenses for approval.",
      expensesManagementDescription:
        "Review submitted claims, approve eligible reimbursements and track payment.",
      openExpenses: "Open expenses",
      noStatements: "No payroll statements yet.",
      noCertificates: "No salary certificates yet.",
      grossIncome: "Gross income",
      netIncome: "Net income",
      downloadPdf: "Download PDF",
      downloadXml: "Download XML",
      downloadReceipt: "Download submission receipt",
      retrySubmission: "Retry submission",
      submissionStatus: {
        configuration_required: "Connector configuration required",
        pending: "Submission queued",
        submitting: "Submitting",
        processing: "Authority processing",
        completed: "Submitted successfully",
        failed: "Submission failed",
      },
      status: {
        draft: "Draft",
        final: "Final",
      },
      salaryType: "Salary type",
      monthly: "Monthly",
      hourly: "Hourly",
      salaryAmount: "Salary amount",
      salaryBasis: "Monthly amount represents",
      effectivePensum: "Effective pensum salary",
      fullTime: "100% full-time salary",
      thirteenth: "13th-month salary enabled",
      newStatement: "New payroll statement",
      period: "Period",
      gross: "Gross",
      deductions: "Deductions",
      net: "Net",
      statementEditor: "Payroll statement",
      loadSuggestions: "Load salary and deduction suggestions",
      earning: "Earning",
      deduction: "Deduction",
      employerContribution: "Employer contribution",
      information: "Information",
      reimbursement: "Reimbursement",
      addLine: "Add line",
      code: "Code",
      label: "Label",
      kind: "Kind",
      amount: "Amount",
      lineLabels: {
        BASIC: "Base salary",
        AHV: "AHV / IV / EO (5.3%)",
        ALV: "Unemployment insurance (1.1%)",
        NBUV: "Non-occupational accident insurance",
        BVG: "Occupational pension (BVG/LPP)",
        KTG: "Daily sickness allowance insurance",
        SOURCE_TAX: "Withholding tax",
        HOURLY: "Hourly salary",
        "13TH": "13th-month salary",
        REIMBURSEMENT: "Expense reimbursement",
      },
      finalize: "Finalize PDF & XML",
      finalizeConfirm:
        "Finalize this statement? It becomes immutable and a PDF is created.",
      newCertificate: "New salary certificate",
      certificateEditor: "Swiss salary certificate",
      loadAnnualTotals: "Load finalized payroll totals",
      freeTransport: "Free transport",
      canteen: "Canteen / lunch checks",
      otherFringeBenefits: "14 Other fringe benefits",
      remarks: "15 Remarks",
      certificateFinalizeConfirm:
        "Finalize this salary certificate? PDF and eLohn XML become immutable.",
      certificate: {
        salary: "1 Salary / pension",
        foodLodging: "2.1 Food and lodging",
        privateCar: "2.2 Private share of company car",
        otherFringeAmount: "2.3 Other fringe benefits",
        sporadicAmount: "3 Sporadic benefits",
        capitalAmount: "4 Capital payment",
        participationRights: "5 Participation rights",
        boardCompensation: "6 Board compensation",
        otherBenefitsAmount: "7 Other benefits",
        socialContributions: "9 Social contributions",
        pensionRegular: "10.1 Occupational pension",
        pensionPurchase: "10.2 Pension purchase",
        withholdingTax: "12 Withholding tax",
        travelExpenses: "13.1.1 Travel expenses",
        otherEffectiveAmount: "13.1.2 Other effective expenses",
        representationExpenses: "13.2.1 Representation expenses",
        carExpenses: "13.2.2 Car expenses",
        otherLumpAmount: "13.2.3 Other lump-sum expenses",
        educationContributions: "13.3 Education contributions",
        otherFringeDescription: "Other fringe benefit description",
        sporadicDescription: "Sporadic benefit description",
        capitalDescription: "Capital payment description",
        otherBenefitsDescription: "Other benefits description",
        otherEffectiveDescription: "Other effective expense description",
        otherLumpDescription: "Other lump-sum expense description",
      },
    },
  },
  de: {
    nav: {
      employees: "Mitarbeitende",
      time: "Meine Zeit",
      clock: "Stempeluhr",
      assignments: "Zuweisungen",
    },
    weekdays: {
      monday: "Montag",
      tuesday: "Dienstag",
      wednesday: "Mittwoch",
      thursday: "Donnerstag",
      friday: "Freitag",
      saturday: "Samstag",
      sunday: "Sonntag",
    },
    employees: {
      title: "Mitarbeitende",
      currentPassword: "Aktuelles Passwort",
      changeEmail: "E-Mail-Adresse ändern",
      newEmail: "Neue E-Mail-Adresse",
      requestEmailChange: "E-Mail-Änderung anfordern",
      emailChangeSent: "Bestätigungs-E-Mail gesendet.",
      languageHelp: "Wählen Sie die Sprache für Ihr Mitarbeitendenportal.",
      newChangeRequest: "Neuer Änderungsantrag",
      changeRequestHelp:
        "Reichen Sie Profil-, E-Mail- oder Austrittsänderungen zur Genehmigung ein.",
      requestType: "Antragstyp",
      offboardingDate: "Austrittsdatum",
      offboardNow: "Anstellung jetzt beenden",
      submitChangeRequest: "Antrag einreichen",
      changeRequestHistory: "Verlauf der Änderungsanträge",
      noChangeRequests: "Noch keine Änderungsanträge.",
      calendarFeedHelp:
        "Erstellen Sie einen privaten iCalendar-Feed für erlaubte Arbeitsaufträge und Firmenfeiertage.",
      createCalendarFeed: "Kalender-Feed erstellen",
      rotateCalendarFeed: "Kalender-Feed rotieren",
      revokeCalendarFeed: "Kalender-Feed widerrufen",
      calendarFeedUrl: "Kalender-Feed-URL",
      pendingChangeRequests: "Offene Änderungsanträge",
      approveChange: "Genehmigen",
      rejectChange: "Ablehnen",
      decisionNote: "Entscheidungsnotiz",
      ahvPlaceholder: "z. B. 756.1234.5678.97",
      myData: "Meine Daten",
      security: "Sicherheit",
      language: "Sprache",
      changeRequests: "Änderungsanträge",
      calendarFeed: "Kalender-Feed",
      actions: "Management-Aktionen",
      bankName: "Bankname",
      bankIban: "IBAN",
      employmentEndEnabled: "Enddatum der Anstellung aktiviert",
      noEmploymentEnd: "Kein Enddatum der Anstellung",
      subtitle:
        "Personen, Anstellungsdaten, Zeitguthaben und Personaldokumente.",
      search: "Mitarbeitende suchen",
      empty: "Keine Mitarbeitenden gefunden.",
      overview: "Übersicht",
      timeBalances: "Zeit & Guthaben",
      employmentProfile: "Anstellungsprofil",
      editProfile: "Anstellungsprofil bearbeiten",
      employeeNumber: "Personalnummer",
      jobTitle: "Funktion",
      pensum: "Pensum",
      phone: "Telefon",
      dateOfBirth: "Geburtsdatum",
      nationality: "Nationalität",
      ahvNumber: "AHV-Nummer",
      employmentStart: "Anstellungsbeginn",
      employmentEnd: "Anstellungsende",
      address: "Adresse",
      addressLine1: "Adresszeile 1",
      addressLine2: "Adresszeile 2",
      postalCode: "Postleitzahl",
      city: "Ort",
      country: "Land",
      weeklySchedule: "Wochenarbeitsplan",
      minutesHelp: "Geplante Minuten pro Tag. 504 Minuten = 8 Std. 24 Min.",
      balances: "Ferien & Kompensation",
      vacationUsed: "Ferien bezogen",
      vacationRemaining: "Ferienguthaben",
      compensationEarned: "Kompensation erarbeitet",
      compensationRemaining: "Kompensationssaldo",
      vacationGranted: "Ferienanspruch (Minuten)",
      vacationWeeksOverride: "Individuelle Ferienwochen",
      vacationAdjustment: "Ferienkorrektur (Minuten)",
      compensationAdjustment: "Kompensationskorrektur (Minuten)",
      changePassword: "Passwort ändern",
      lifecycle: "Mitarbeitenden-Lebenszyklus",
      deactivatedHelp:
        "Das Konto ist deaktiviert. Frühere Arbeiten, Dokumente und Lohndaten bleiben erhalten.",
      reactivate: "Mitarbeitende reaktivieren",
      offboardingReason: "Grund",
      offboard: "Mitarbeitende austreten lassen",
      offboardConfirm:
        "Dieses Mitarbeitendenkonto deaktivieren und alle historischen Daten behalten?",
      requestKind: {
        profile: "Profiländerung",
        email: "E-Mail-Änderung",
        offboard: "Austritt",
      },
      requestStatus: {
        pending: "Ausstehend",
        verified: "Verifiziert",
        approved: "Genehmigt",
        rejected: "Abgelehnt",
        cancelled: "Storniert",
      },
    },
    documents: {
      title: "Dokumente",
      upload: "Dokument hochladen",
      chooseFile: "Datei auswählen",
      empty: "Noch keine Dokumente.",
      deleteConfirm: "Dieses Dokument löschen?",
      newUpload: "Neues Dokument",
      category: "Kategorie",
      visibility: "Sichtbarkeit",
      employeeVisible: "Für Mitarbeitende sichtbar",
      managementOnly: "Nur Geschäftsleitung",
    },
    time: {
      myTime: "Meine Zeit",
      subtitle: "Arbeitszeit und Absenzen erfassen und Projektzeiten zuweisen.",
      clock: "Ein- und ausstempeln",
      clockDescription:
        "Erfassen Sie die heutige Präsenz mit einer klaren Aktion.",
      assignments: "Zeitzuweisungen",
      assignmentsDescription:
        "Weisen Sie Arbeitszeit Projekten zu und erfassen Sie Absenzen.",
      clockedInSince: "Eingestempelt seit {{time}}",
      noOpenSession: "Keine aktive Präsenzsitzung.",
      todayStamped: "Heute gestempelt",
      dailyGoalDifference: "Differenz zum Tagesziel",
      todaySessions: "Heutige Stempelsitzungen",
      dailyGoal: "Tagesziel: {{value}}",
      inProgress: "Laufend",
      noSessionsToday: "Heute noch keine Stempelsitzung.",
      assignmentMatrix: "Zuweisungsmatrix",
      assignmentMatrixDescription:
        "Projektzeit direkt für einen Tag, eine Woche oder einen Monat zuweisen.",
      editAllocationCell: "{{project}} am {{date}} bearbeiten",
      viewDay: "Tag",
      viewWeek: "Woche",
      viewMonth: "Monat",
      previousPeriod: "Vorheriger Zeitraum",
      nextPeriod: "Nächster Zeitraum",
      available: "Verfügbar",
      noEligibleProjects: "Keine verfügbaren Projekte.",
      team: "Team-Zeiten",
      teamSubtitle:
        "Arbeitszeiten, Absenzen, Projektzuweisungen und Wochenfreigaben prüfen.",
      weekOf: "Woche ab",
      stamp: "Live-Zeiterfassung",
      clockIn: "Einstempeln",
      clockOut: "Ausstempeln",
      lunch: "Mittag",
      planned: "Sollzeit",
      worked: "Arbeitszeit",
      projectTime: "Projektzeit",
      weekBalance: "Wochensaldo",
      rejected: "Abgelehnt",
      week: "Woche",
      ofPlanned: "von {{value}} Sollzeit",
      entries: "Arbeitszeit & Absenzen",
      addEntry: "Eintrag hinzufügen",
      allocations: "Projektzuweisungen",
      allocate: "Projektzeit zuweisen",
      submitWeek: "Woche einreichen",
      unallocated: "Nicht zugewiesene Projektzeit",
      validation: "Prüfung",
      issues: "Probleme",
      complete: "Vollständig",
      submit: "Zur Genehmigung einreichen",
      type: "Typ",
      start: "Beginn",
      end: "Ende",
      minutes: "Minuten",
      project: "Auftrag",
      deleteEntryConfirm: "Diesen Zeiteintrag löschen?",
      deleteAllocationConfirm: "Diese Projektzuweisung löschen?",
      approve: "Genehmigen",
      reject: "Ablehnen",
      rejectReason: "Ablehnungsgrund",
      reopen: "Wieder öffnen",
      reopenConfirm: "Diesen genehmigten Stundenzettel wieder öffnen?",
      holidays: "Betriebsfeiertage",
      holidayName: "Feiertagsname",
      paid: "Bezahlt",
      unpaid: "unbezahlt",
      status: {
        draft: "Entwurf",
        submitted: "Eingereicht",
        approved: "Genehmigt",
        rejected: "Abgelehnt",
      },
      kind: {
        attendance: "Arbeitszeit",
        break: "Pause",
        vacation: "Ferien",
        sick: "Krankheit",
        military: "Militärdienst",
        accident: "Unfall",
        compensation_leave: "Kompensationsbezug",
        unpaid_leave: "Unbezahlter Urlaub",
        other_absence: "Andere Absenz",
      },
      workflow: {
        worked: "Arbeitszeit",
        previousWeek: "Vorherige Woche",
        nextWeek: "Nächste Woche",
        clockState: "Stempelstatus",
        clockedIn: "Eingestempelt",
        clockedOut: "Ausgestempelt",
        todaySummary: "Zusammenfassung heute",
        weekNotCurrent:
          "Wählen Sie die aktuelle Woche für die Live-Zeiterfassung.",
        break: "Pause",
        paidBreak: "Bezahlte Pause",
        unpaidBreak: "Unbezahlte Pause",
        absence: "Absenz",
        remaining: "Restzeit",
        details: "Details",
        actions: "Aktionen",
        noEntries: "Keine Arbeitszeit- oder Absenz-Einträge.",
        noAllocations: "Keine Projektzuweisungen.",
        noNotes: "Keine Notizen",
        editEntry: "Zeiteintrag bearbeiten",
        newEntry: "Neuer Zeiteintrag",
        allocateTitle: "Arbeitszeit zuweisen",
        searchProjects: "Zuweisbare Projekte suchen",
        remainingByDay: "Restzeit pro Tag",
        allocateRemaining: "Restzeit heute zuweisen",
        allocateRemainingWeek: "Restzeit der Woche zuweisen",
        breaksPaidNotice:
          "Pausen sind bezahlt und reduzieren die Arbeitszeit nicht.",
        issueCount: "{{count}} Probleme",
        noIssues: "Keine offenen Punkte. Die Woche ist bereit zur Einreichung.",
        approval: {
          draft: "Entwurf — nicht eingereicht",
          submitted: "Zur Genehmigung eingereicht",
          approved: "Genehmigt",
          rejected: "Abgelehnt — Änderungen vornehmen und erneut einreichen",
        },
        issue: {
          open_stamp: "Vor dem Einreichen ausstempeln.",
          missing_day: "Keine Arbeit oder Absenz erfasst.",
          allocation_mismatch:
            "Gesamte Arbeitszeit zuweisen ({{worked}} Minuten gearbeitet, {{allocated}} zugewiesen).",
          vacation_overdrawn:
            "Ferienbuchungen überschreiten das verfügbare Guthaben.",
          unknown: "Erforderliche Zeitangaben vervollständigen.",
        },
        errors: {
          generic: "Die Zeitänderung konnte nicht gespeichert werden.",
          conflict: "Der Stundenzettel wurde geändert. Woche neu laden.",
          forbidden: "Diese Zeitangaben dürfen nicht geändert werden.",
          validation: "Zeitfelder prüfen und ungültige Werte korrigieren.",
        },
        breakPresetMorning: "Vormittagspause · 09:00",
        breakPresetLunch: "Mittagspause · 12:00",
        breakPresetAfternoon: "Nachmittagspause · 15:00",
      },
      teamManagement: {
        search: "Mitarbeitende suchen",
        searchPlaceholder: "Name oder E-Mail",
        statusFilter: "Stundenzettelstatus",
        allStatuses: "Alle Status",
        previousWeek: "Vorherige Woche",
        nextWeek: "Nächste Woche",
        holidaySummary: "Betriebsfeiertage dieser Woche",
        paidHoliday: "Bezahlt",
        unpaidHoliday: "Unbezahlt",
        dayBreakdown: "Tagesdetails",
        attendance: "Arbeitszeit",
        breaks: "Pausen",
        netAttendance: "Nettoarbeitszeit",
        allocated: "Zugewiesen",
        absences: "Absenzen",
        projects: "Aufträge",
        noProjects: "Keine Aufträge zugewiesen.",
        noDays: "Keine Zeiteinträge für diese Woche.",
        noTimesheet: "Kein Stundenzettel",
        actions: "Aktionen",
        rejectionReason: "Ablehnungsgrund",
        rejectDialogTitle: "Stundenzettel von {{name}} ablehnen",
        rejectReasonHint:
          "Erklären Sie, was vor der erneuten Einreichung korrigiert werden muss.",
        rejectReasonRequired: "Ein Ablehnungsgrund ist erforderlich.",
        empty: "Keine Mitarbeitenden entsprechen diesen Filtern.",
      },
    },
    payroll: {
      title: "Lohn",
      actions: "Aktionen",
      statements: "Lohnabrechnungen",
      certificates: "Lohnausweise",
      salarySettings: "Lohneinstellungen",
      expenses: "Spesen",
      expensesTitle: "Spesenabrechnungen",
      expensesDescription:
        "Spesen erfassen, einreichen, prüfen und Belege anhängen.",
      expensesEmployeeDescription:
        "Reise-, Verpflegungs- und andere erstattungsfähige Spesen einreichen.",
      expensesManagementDescription:
        "Eingereichte Spesen prüfen, Erstattungen genehmigen und Zahlungen verfolgen.",
      openExpenses: "Spesen öffnen",
      noStatements: "Noch keine Lohnabrechnungen.",
      noCertificates: "Noch keine Lohnausweise.",
      grossIncome: "Bruttoeinkommen",
      netIncome: "Nettoeinkommen",
      downloadPdf: "PDF herunterladen",
      downloadXml: "XML herunterladen",
      downloadReceipt: "Übermittlungsbeleg herunterladen",
      retrySubmission: "Übermittlung wiederholen",
      submissionStatus: {
        configuration_required: "Connector-Konfiguration erforderlich",
        pending: "Übermittlung eingereiht",
        submitting: "Wird übermittelt",
        processing: "Wird von der Behörde verarbeitet",
        completed: "Erfolgreich übermittelt",
        failed: "Übermittlung fehlgeschlagen",
      },
      status: {
        draft: "Entwurf",
        final: "Final",
      },
      salaryType: "Lohnart",
      monthly: "Monatslohn",
      hourly: "Stundenlohn",
      salaryAmount: "Lohnbetrag",
      salaryBasis: "Monatsbetrag entspricht",
      effectivePensum: "Effektivem Pensum",
      fullTime: "100%-Vollzeitlohn",
      thirteenth: "13. Monatslohn aktiviert",
      newStatement: "Neue Lohnabrechnung",
      period: "Periode",
      gross: "Brutto",
      deductions: "Abzüge",
      net: "Netto",
      statementEditor: "Lohnabrechnung",
      loadSuggestions: "Lohn- und Abzugsvorschläge laden",
      earning: "Lohnbestandteil",
      deduction: "Abzug",
      employerContribution: "Arbeitgeberbeitrag",
      information: "Information",
      reimbursement: "Erstattung",
      addLine: "Zeile hinzufügen",
      code: "Code",
      label: "Bezeichnung",
      kind: "Art",
      amount: "Betrag",
      lineLabels: {
        BASIC: "Grundlohn",
        AHV: "AHV / IV / EO (5,3 %)",
        ALV: "Arbeitslosenversicherung (1,1 %)",
        NBUV: "Nichtberufsunfallversicherung",
        BVG: "Berufliche Vorsorge (BVG)",
        KTG: "Krankentaggeldversicherung",
        SOURCE_TAX: "Quellensteuer",
        HOURLY: "Stundenlohn",
        "13TH": "13. Monatslohn",
        REIMBURSEMENT: "Spesenerstattung",
      },
      finalize: "PDF & XML abschliessen",
      finalizeConfirm:
        "Diese Abrechnung abschliessen? Sie wird unveränderbar und als PDF erstellt.",
      newCertificate: "Neuer Lohnausweis",
      certificateEditor: "Schweizer Lohnausweis",
      loadAnnualTotals: "Finalisierte Jahressummen laden",
      freeTransport: "Unentgeltliche Beförderung",
      canteen: "Kantinenverpflegung / Lunch-Checks",
      otherFringeBenefits: "14 Weitere Gehaltsnebenleistungen",
      remarks: "15 Bemerkungen",
      certificateFinalizeConfirm:
        "Diesen Lohnausweis abschliessen? PDF und eLohn-XML werden unveränderbar.",
      certificate: {
        salary: "1 Lohn / Rente",
        foodLodging: "2.1 Verpflegung und Unterkunft",
        privateCar: "2.2 Privatanteil Geschäftswagen",
        otherFringeAmount: "2.3 Übrige Gehaltsnebenleistungen",
        sporadicAmount: "3 Unregelmässige Leistungen",
        capitalAmount: "4 Kapitalleistungen",
        participationRights: "5 Beteiligungsrechte",
        boardCompensation: "6 Verwaltungsratsentschädigungen",
        otherBenefitsAmount: "7 Andere Leistungen",
        socialContributions: "9 AHV/IV/EO/ALV/NBUV-Beiträge",
        pensionRegular: "10.1 Berufliche Vorsorge",
        pensionPurchase: "10.2 Einkauf berufliche Vorsorge",
        withholdingTax: "12 Quellensteuer",
        travelExpenses: "13.1.1 Reise-, Verpflegungs-, Übernachtungsspesen",
        otherEffectiveAmount: "13.1.2 Übrige effektive Spesen",
        representationExpenses: "13.2.1 Repräsentationsspesen",
        carExpenses: "13.2.2 Autospesen",
        otherLumpAmount: "13.2.3 Übrige Pauschalspesen",
        educationContributions: "13.3 Beiträge an Weiterbildung",
        otherFringeDescription: "Beschreibung Nebenleistung",
        sporadicDescription: "Beschreibung unregelmässige Leistung",
        capitalDescription: "Beschreibung Kapitalleistung",
        otherBenefitsDescription: "Beschreibung andere Leistung",
        otherEffectiveDescription: "Beschreibung effektive Spesen",
        otherLumpDescription: "Beschreibung Pauschalspesen",
      },
    },
  },
  fr: {
    nav: {
      employees: "Collaborateurs",
      time: "Mon temps",
      clock: "Pointeuse",
      assignments: "Affectations",
    },
    weekdays: {
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche",
    },
    employees: {
      title: "Collaborateurs",
      currentPassword: "Mot de passe actuel",
      changeEmail: "Modifier l’adresse e-mail",
      newEmail: "Nouvelle adresse e-mail",
      requestEmailChange: "Demander la modification de l’e-mail",
      emailChangeSent: "E-mail de confirmation envoyé.",
      languageHelp:
        "Choisissez la langue utilisée dans votre portail collaborateur.",
      newChangeRequest: "Nouvelle demande de modification",
      changeRequestHelp:
        "Soumettez les modifications de profil, d’e-mail ou de départ à la direction.",
      requestType: "Type de demande",
      offboardingDate: "Date de départ",
      offboardNow: "Terminer l’emploi maintenant",
      submitChangeRequest: "Soumettre la demande",
      changeRequestHistory: "Historique des demandes de modification",
      noChangeRequests: "Aucune demande de modification.",
      calendarFeedHelp:
        "Créez un flux iCalendar privé avec vos ordres de travail autorisés et les jours fériés de l’entreprise.",
      createCalendarFeed: "Créer un flux de calendrier",
      rotateCalendarFeed: "Faire tourner le flux de calendrier",
      revokeCalendarFeed: "Révoquer le flux de calendrier",
      calendarFeedUrl: "URL du flux de calendrier",
      pendingChangeRequests: "Demandes de modification en attente",
      approveChange: "Approuver",
      rejectChange: "Refuser",
      decisionNote: "Note de décision",
      ahvPlaceholder: "p. ex. 756.1234.5678.97",
      myData: "Mes données",
      security: "Sécurité",
      language: "Langue",
      changeRequests: "Demandes de modification",
      calendarFeed: "Flux de calendrier",
      actions: "Actions de gestion",
      bankName: "Nom de la banque",
      bankIban: "IBAN",
      employmentEndEnabled: "Date de fin d’emploi activée",
      noEmploymentEnd: "Aucune date de fin d’emploi",
      subtitle:
        "Personnes, données d’emploi, soldes de temps et documents du personnel.",
      search: "Rechercher des collaborateurs",
      empty: "Aucun collaborateur trouvé.",
      overview: "Aperçu",
      timeBalances: "Temps et soldes",
      employmentProfile: "Profil d’emploi",
      editProfile: "Modifier le profil d’emploi",
      employeeNumber: "Numéro de personnel",
      jobTitle: "Fonction",
      pensum: "Taux d’activité",
      phone: "Téléphone",
      dateOfBirth: "Date de naissance",
      nationality: "Nationalité",
      ahvNumber: "Numéro AVS",
      employmentStart: "Début de l’emploi",
      employmentEnd: "Fin de l’emploi",
      address: "Adresse",
      addressLine1: "Adresse ligne 1",
      addressLine2: "Adresse ligne 2",
      postalCode: "Code postal",
      city: "Localité",
      country: "Pays",
      weeklySchedule: "Horaire hebdomadaire",
      minutesHelp: "Minutes planifiées par jour. 504 minutes = 8 h 24.",
      balances: "Vacances et compensation",
      vacationUsed: "Vacances prises",
      vacationRemaining: "Solde de vacances",
      compensationEarned: "Compensation acquise",
      compensationRemaining: "Solde de compensation",
      vacationGranted: "Droit aux vacances (minutes)",
      vacationWeeksOverride: "Semaines de vacances individuelles",
      vacationAdjustment: "Correction vacances (minutes)",
      compensationAdjustment: "Correction compensation (minutes)",
      changePassword: "Modifier le mot de passe",
      lifecycle: "Cycle de vie du collaborateur",
      deactivatedHelp:
        "Le compte est désactivé. Les travaux, documents et données salariales historiques sont conservés.",
      reactivate: "Réactiver le collaborateur",
      offboardingReason: "Motif",
      offboard: "Faire sortir le collaborateur",
      offboardConfirm:
        "Désactiver ce compte tout en conservant toutes les données historiques ?",
      requestKind: {
        profile: "Modification du profil",
        email: "Modification de l’e-mail",
        offboard: "Départ",
      },
      requestStatus: {
        pending: "En attente",
        verified: "Vérifiée",
        approved: "Approuvée",
        rejected: "Refusée",
        cancelled: "Annulée",
      },
    },
    documents: {
      title: "Documents",
      upload: "Téléverser un document",
      chooseFile: "Choisir un fichier",
      empty: "Aucun document.",
      deleteConfirm: "Supprimer ce document ?",
      newUpload: "Nouveau document",
      category: "Catégorie",
      visibility: "Visibilité",
      employeeVisible: "Visible par le collaborateur",
      managementOnly: "Direction uniquement",
    },
    time: {
      myTime: "Mon temps",
      subtitle:
        "Saisir les présences et absences et attribuer le temps aux projets.",
      clock: "Pointer l’entrée et la sortie",
      clockDescription: "Enregistrez la présence du jour en une seule action.",
      assignments: "Affectations de temps",
      assignmentsDescription:
        "Affectez le temps travaillé aux projets et saisissez les absences.",
      clockedInSince: "Pointé depuis {{time}}",
      noOpenSession: "Aucune session de présence active.",
      todayStamped: "Pointé aujourd’hui",
      dailyGoalDifference: "Écart par rapport à l’objectif quotidien",
      todaySessions: "Sessions de pointage du jour",
      dailyGoal: "Objectif quotidien : {{value}}",
      inProgress: "En cours",
      noSessionsToday: "Aucune session de pointage aujourd’hui.",
      assignmentMatrix: "Matrice d’affectation",
      assignmentMatrixDescription:
        "Affecter le temps aux projets par jour, semaine ou mois.",
      editAllocationCell: "Modifier {{project}} le {{date}}",
      viewDay: "Jour",
      viewWeek: "Semaine",
      viewMonth: "Mois",
      previousPeriod: "Période précédente",
      nextPeriod: "Période suivante",
      available: "Disponible",
      noEligibleProjects: "Aucun projet disponible.",
      team: "Temps de l’équipe",
      teamSubtitle:
        "Contrôler les présences, absences, affectations de projet et validations hebdomadaires.",
      weekOf: "Semaine du",
      stamp: "Pointage en direct",
      clockIn: "Pointer l’arrivée",
      clockOut: "Pointer le départ",
      lunch: "Midi",
      planned: "Planifié",
      worked: "Travaillé",
      projectTime: "Temps projet",
      weekBalance: "Solde hebdomadaire",
      rejected: "Refusé",
      week: "Semaine",
      ofPlanned: "sur {{value}} planifié",
      entries: "Présences et absences",
      addEntry: "Ajouter une saisie",
      allocations: "Affectations aux projets",
      allocate: "Affecter du temps",
      submitWeek: "Soumettre la semaine",
      unallocated: "Temps projet non affecté",
      validation: "Validation",
      issues: "problèmes",
      complete: "Complet",
      submit: "Soumettre pour approbation",
      type: "Type",
      start: "Début",
      end: "Fin",
      minutes: "Minutes",
      project: "Ordre de travail",
      deleteEntryConfirm: "Supprimer cette saisie de temps ?",
      deleteAllocationConfirm: "Supprimer cette affectation ?",
      approve: "Approuver",
      reject: "Refuser",
      rejectReason: "Motif du refus",
      reopen: "Rouvrir",
      reopenConfirm: "Rouvrir cette feuille de temps approuvée ?",
      holidays: "Jours fériés d’entreprise",
      holidayName: "Nom du jour férié",
      paid: "Payé",
      unpaid: "non payé",
      status: {
        draft: "Brouillon",
        submitted: "Soumis",
        approved: "Approuvé",
        rejected: "Refusé",
      },
      kind: {
        attendance: "Présence",
        break: "Pause",
        vacation: "Vacances",
        sick: "Maladie",
        military: "Service militaire",
        accident: "Accident",
        compensation_leave: "Congé compensatoire",
        unpaid_leave: "Congé non payé",
        other_absence: "Autre absence",
      },
      workflow: {
        worked: "Travaillé",
        previousWeek: "Semaine précédente",
        nextWeek: "Semaine suivante",
        clockState: "État du pointage",
        clockedIn: "Pointé à l’arrivée",
        clockedOut: "Pointé au départ",
        todaySummary: "Résumé du jour",
        weekNotCurrent:
          "Sélectionnez la semaine actuelle pour le pointage en direct.",
        break: "Pause",
        paidBreak: "Pause payée",
        unpaidBreak: "Pause non payée",
        absence: "Absence",
        remaining: "Temps restant",
        details: "Détails",
        actions: "Actions",
        noEntries: "Aucune saisie de présence ou d’absence.",
        noAllocations: "Aucune affectation de projet.",
        noNotes: "Aucune note",
        editEntry: "Modifier la saisie",
        newEntry: "Nouvelle saisie",
        allocateTitle: "Affecter du temps de travail",
        searchProjects: "Rechercher des projets éligibles",
        remainingByDay: "Temps restant par jour",
        allocateRemaining: "Affecter le restant aujourd’hui",
        allocateRemainingWeek: "Affecter le restant de la semaine",
        breaksPaidNotice:
          "Les pauses sont payées et ne réduisent pas le temps travaillé.",
        issueCount: "{{count}} problèmes",
        noIssues: "Aucun élément incomplet. La semaine peut être soumise.",
        approval: {
          draft: "Brouillon — non soumis",
          submitted: "Soumis pour approbation",
          approved: "Approuvé",
          rejected: "Refusé — corrigez puis soumettez à nouveau",
        },
        issue: {
          open_stamp: "Pointez le départ avant de soumettre.",
          missing_day: "Aucune présence ou absence enregistrée.",
          allocation_mismatch:
            "Affectez tout le temps travaillé ({{worked}} minutes travaillées, {{allocated}} affectées).",
          vacation_overdrawn: "Les vacances dépassent le solde disponible.",
          unknown: "Complétez les informations de temps requises.",
        },
        errors: {
          generic: "La modification du temps n’a pas pu être enregistrée.",
          conflict: "La feuille a changé. Rechargez la semaine.",
          forbidden: "Vous ne pouvez pas modifier ces données de temps.",
          validation:
            "Vérifiez les champs de temps et corrigez les valeurs invalides.",
        },
        breakPresetMorning: "Pause du matin · 09:00",
        breakPresetLunch: "Pause de midi · 12:00",
        breakPresetAfternoon: "Pause de l’après-midi · 15:00",
      },
      teamManagement: {
        search: "Rechercher des employés",
        searchPlaceholder: "Nom ou e-mail",
        statusFilter: "Statut de la feuille de temps",
        allStatuses: "Tous les statuts",
        previousWeek: "Semaine précédente",
        nextWeek: "Semaine suivante",
        holidaySummary: "Jours fériés de l’entreprise cette semaine",
        paidHoliday: "Payé",
        unpaidHoliday: "Non payé",
        dayBreakdown: "Détail quotidien",
        attendance: "Présence",
        breaks: "Pauses",
        netAttendance: "Présence nette",
        allocated: "Affecté",
        absences: "Absences",
        projects: "Ordres de travail",
        noProjects: "Aucun ordre de travail affecté.",
        noDays: "Aucune saisie de temps cette semaine.",
        noTimesheet: "Aucune feuille de temps",
        actions: "Actions",
        rejectionReason: "Motif du refus",
        rejectDialogTitle: "Refuser la feuille de temps de {{name}}",
        rejectReasonHint:
          "Indiquez ce qui doit être corrigé avant une nouvelle soumission.",
        rejectReasonRequired: "Un motif de refus est obligatoire.",
        empty: "Aucun employé ne correspond à ces filtres.",
      },
    },
    payroll: {
      title: "Salaires",
      actions: "Actions",
      statements: "Décomptes de salaire",
      certificates: "Certificats de salaire",
      salarySettings: "Paramètres salariaux",
      expenses: "Dépenses",
      expensesTitle: "Notes de frais",
      expensesDescription:
        "Créer, soumettre et examiner des notes de frais avec justificatifs.",
      expensesEmployeeDescription:
        "Soumettre les frais de voyage, de repas et autres frais remboursables.",
      expensesManagementDescription:
        "Examiner les notes soumises, approuver les remboursements et suivre les paiements.",
      openExpenses: "Ouvrir les dépenses",
      noStatements: "Aucun décompte de salaire.",
      noCertificates: "Aucun certificat de salaire.",
      grossIncome: "Revenu brut",
      netIncome: "Revenu net",
      downloadPdf: "Télécharger le PDF",
      downloadXml: "Télécharger le XML",
      downloadReceipt: "Télécharger le reçu d’envoi",
      retrySubmission: "Réessayer l’envoi",
      submissionStatus: {
        configuration_required: "Configuration du connecteur requise",
        pending: "Envoi en attente",
        submitting: "Envoi en cours",
        processing: "Traitement par l’autorité",
        completed: "Envoyé avec succès",
        failed: "Échec de l’envoi",
      },
      status: {
        draft: "Brouillon",
        final: "Final",
      },
      salaryType: "Type de salaire",
      monthly: "Mensuel",
      hourly: "Horaire",
      salaryAmount: "Montant du salaire",
      salaryBasis: "Le montant mensuel représente",
      effectivePensum: "Le taux d’activité effectif",
      fullTime: "Le salaire à 100 %",
      thirteenth: "13e salaire activé",
      newStatement: "Nouveau décompte",
      period: "Période",
      gross: "Brut",
      deductions: "Déductions",
      net: "Net",
      statementEditor: "Décompte de salaire",
      loadSuggestions: "Charger les propositions de salaire et déductions",
      earning: "Élément salarial",
      deduction: "Déduction",
      employerContribution: "Cotisation employeur",
      information: "Information",
      reimbursement: "Remboursement",
      addLine: "Ajouter une ligne",
      code: "Code",
      label: "Libellé",
      kind: "Type",
      amount: "Montant",
      lineLabels: {
        BASIC: "Salaire de base",
        AHV: "AVS / AI / APG (5,3 %)",
        ALV: "Assurance-chômage (1,1 %)",
        NBUV: "Assurance-accidents non professionnels",
        BVG: "Prévoyance professionnelle (LPP)",
        KTG: "Assurance d’indemnités journalières maladie",
        SOURCE_TAX: "Impôt à la source",
        HOURLY: "Salaire horaire",
        "13TH": "13e salaire",
        REIMBURSEMENT: "Remboursement de frais",
      },
      finalize: "Finaliser PDF et XML",
      finalizeConfirm:
        "Finaliser ce décompte ? Il devient immuable et un PDF est créé.",
      newCertificate: "Nouveau certificat de salaire",
      certificateEditor: "Certificat de salaire suisse",
      loadAnnualTotals: "Charger les totaux annuels finalisés",
      freeTransport: "Transport gratuit",
      canteen: "Cantine / chèques-repas",
      otherFringeBenefits: "14 Autres prestations accessoires",
      remarks: "15 Remarques",
      certificateFinalizeConfirm:
        "Finaliser ce certificat ? Le PDF et le XML eLohn deviennent immuables.",
      certificate: {
        salary: "1 Salaire / rente",
        foodLodging: "2.1 Nourriture et logement",
        privateCar: "2.2 Part privée voiture de service",
        otherFringeAmount: "2.3 Autres prestations accessoires",
        sporadicAmount: "3 Prestations irrégulières",
        capitalAmount: "4 Prestations en capital",
        participationRights: "5 Droits de participation",
        boardCompensation: "6 Indemnités de conseil",
        otherBenefitsAmount: "7 Autres prestations",
        socialContributions: "9 Cotisations AVS/AI/APG/AC/AANP",
        pensionRegular: "10.1 Prévoyance professionnelle",
        pensionPurchase: "10.2 Rachat de prévoyance",
        withholdingTax: "12 Impôt à la source",
        travelExpenses: "13.1.1 Frais de voyage et repas",
        otherEffectiveAmount: "13.1.2 Autres frais effectifs",
        representationExpenses: "13.2.1 Frais de représentation",
        carExpenses: "13.2.2 Frais de voiture",
        otherLumpAmount: "13.2.3 Autres frais forfaitaires",
        educationContributions: "13.3 Contributions à la formation",
        otherFringeDescription: "Description prestation accessoire",
        sporadicDescription: "Description prestation irrégulière",
        capitalDescription: "Description prestation en capital",
        otherBenefitsDescription: "Description autre prestation",
        otherEffectiveDescription: "Description autres frais effectifs",
        otherLumpDescription: "Description autres frais forfaitaires",
      },
    },
  },
  es: {
    nav: {
      employees: "Empleados",
      time: "Mi tiempo",
      clock: "Fichaje",
      assignments: "Asignaciones",
    },
    weekdays: {
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miércoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "Sábado",
      sunday: "Domingo",
    },
    employees: {
      title: "Empleados",
      currentPassword: "Contraseña actual",
      changeEmail: "Cambiar correo electrónico",
      newEmail: "Nuevo correo electrónico",
      requestEmailChange: "Solicitar cambio de correo",
      emailChangeSent: "Correo de confirmación enviado.",
      languageHelp: "Elige el idioma del portal del empleado.",
      newChangeRequest: "Nueva solicitud de cambio",
      changeRequestHelp:
        "Envía cambios de perfil, correo o baja para que la dirección los apruebe.",
      requestType: "Tipo de solicitud",
      offboardingDate: "Fecha de baja",
      offboardNow: "Finalizar el empleo ahora",
      submitChangeRequest: "Enviar solicitud",
      changeRequestHistory: "Historial de solicitudes de cambio",
      noChangeRequests: "Aún no hay solicitudes de cambio.",
      calendarFeedHelp:
        "Crea un feed iCalendar privado con tus órdenes de trabajo permitidas y los festivos de la empresa.",
      createCalendarFeed: "Crear feed de calendario",
      rotateCalendarFeed: "Rotar feed de calendario",
      revokeCalendarFeed: "Revocar feed de calendario",
      calendarFeedUrl: "URL del feed de calendario",
      pendingChangeRequests: "Solicitudes de cambio pendientes",
      approveChange: "Aprobar",
      rejectChange: "Rechazar",
      decisionNote: "Nota de decisión",
      ahvPlaceholder: "p. ej. 756.1234.5678.97",
      subtitle:
        "Personas, datos laborales, saldos de tiempo y documentos del personal.",
      myData: "Mis datos",
      security: "Seguridad",
      language: "Idioma",
      changeRequests: "Solicitudes de cambio",
      calendarFeed: "Fuente de calendario",
      actions: "Acciones de gestión",
      bankName: "Nombre del banco",
      bankIban: "IBAN",
      employmentEndEnabled: "Fecha de fin de empleo activada",
      noEmploymentEnd: "Sin fecha de fin de empleo",
      search: "Buscar empleados",
      empty: "No se encontraron empleados.",
      overview: "Resumen",
      timeBalances: "Tiempo y saldos",
      employmentProfile: "Perfil laboral",
      editProfile: "Editar perfil laboral",
      employeeNumber: "Número de empleado",
      jobTitle: "Puesto",
      pensum: "Jornada",
      phone: "Teléfono",
      dateOfBirth: "Fecha de nacimiento",
      nationality: "Nacionalidad",
      ahvNumber: "Número AVS",
      employmentStart: "Inicio del empleo",
      employmentEnd: "Fin del empleo",
      address: "Dirección",
      addressLine1: "Dirección línea 1",
      addressLine2: "Dirección línea 2",
      postalCode: "Código postal",
      city: "Ciudad",
      country: "País",
      weeklySchedule: "Horario semanal",
      minutesHelp: "Minutos planificados por día. 504 minutos = 8 h 24 min.",
      balances: "Vacaciones y compensación",
      vacationUsed: "Vacaciones usadas",
      vacationRemaining: "Vacaciones restantes",
      compensationEarned: "Compensación acumulada",
      compensationRemaining: "Saldo de compensación",
      vacationGranted: "Vacaciones concedidas (minutos)",
      vacationWeeksOverride: "Semanas de vacaciones individuales",
      vacationAdjustment: "Ajuste de vacaciones (minutos)",
      compensationAdjustment: "Ajuste de compensación (minutos)",
      changePassword: "Cambiar contraseña",
      lifecycle: "Ciclo de vida del empleado",
      deactivatedHelp:
        "La cuenta está desactivada. Se conservan el trabajo, los documentos y los datos salariales históricos.",
      reactivate: "Reactivar empleado",
      offboardingReason: "Motivo",
      offboard: "Dar de baja al empleado",
      offboardConfirm:
        "¿Desactivar esta cuenta conservando todos los datos históricos?",
      requestKind: {
        profile: "Cambio de perfil",
        email: "Cambio de correo",
        offboard: "Baja",
      },
      requestStatus: {
        pending: "Pendiente",
        verified: "Verificada",
        approved: "Aprobada",
        rejected: "Rechazada",
        cancelled: "Cancelada",
      },
    },
    documents: {
      title: "Documentos",
      upload: "Subir documento",
      chooseFile: "Elegir archivo",
      empty: "Aún no hay documentos.",
      deleteConfirm: "¿Eliminar este documento?",
      newUpload: "Nuevo documento",
      category: "Categoría",
      visibility: "Visibilidad",
      employeeVisible: "Visible para el empleado",
      managementOnly: "Solo dirección",
    },
    time: {
      myTime: "Mi tiempo",
      subtitle:
        "Registrar asistencia y ausencias y asignar tiempo a proyectos.",
      clock: "Fichar entrada y salida",
      clockDescription: "Registra la asistencia de hoy con una sola acción.",
      assignments: "Asignaciones de tiempo",
      assignmentsDescription:
        "Asigna el tiempo trabajado a proyectos y registra ausencias.",
      clockedInSince: "Fichado desde las {{time}}",
      noOpenSession: "No hay una sesión de asistencia activa.",
      todayStamped: "Fichado hoy",
      dailyGoalDifference: "Diferencia con el objetivo diario",
      todaySessions: "Sesiones de fichaje de hoy",
      dailyGoal: "Objetivo diario: {{value}}",
      inProgress: "En curso",
      noSessionsToday: "No hay sesiones de fichaje hoy.",
      assignmentMatrix: "Matriz de asignaciones",
      assignmentMatrixDescription:
        "Asignar tiempo a proyectos por día, semana o mes.",
      editAllocationCell: "Editar {{project}} el {{date}}",
      viewDay: "Día",
      viewWeek: "Semana",
      viewMonth: "Mes",
      previousPeriod: "Periodo anterior",
      nextPeriod: "Periodo siguiente",
      available: "Disponible",
      noEligibleProjects: "No hay proyectos disponibles.",
      team: "Tiempo del equipo",
      teamSubtitle:
        "Revisar asistencia, ausencias, asignaciones y aprobaciones semanales.",
      weekOf: "Semana del",
      stamp: "Fichaje en directo",
      clockIn: "Fichar entrada",
      clockOut: "Fichar salida",
      lunch: "Almuerzo",
      planned: "Planificado",
      worked: "Trabajado",
      projectTime: "Tiempo de proyecto",
      weekBalance: "Saldo semanal",
      rejected: "Rechazado",
      week: "Semana",
      ofPlanned: "de {{value}} planificado",
      entries: "Asistencia y ausencias",
      addEntry: "Añadir registro",
      allocations: "Asignaciones a proyectos",
      allocate: "Asignar tiempo",
      submitWeek: "Enviar semana",
      unallocated: "Tiempo de proyecto sin asignar",
      validation: "Validación",
      issues: "problemas",
      complete: "Completo",
      submit: "Enviar para aprobación",
      type: "Tipo",
      start: "Inicio",
      end: "Fin",
      minutes: "Minutos",
      project: "Orden de trabajo",
      deleteEntryConfirm: "¿Eliminar este registro de tiempo?",
      deleteAllocationConfirm: "¿Eliminar esta asignación?",
      approve: "Aprobar",
      reject: "Rechazar",
      rejectReason: "Motivo del rechazo",
      reopen: "Reabrir",
      reopenConfirm: "¿Reabrir esta hoja de horas aprobada?",
      holidays: "Festivos de empresa",
      holidayName: "Nombre del festivo",
      paid: "Pagado",
      unpaid: "no pagado",
      status: {
        draft: "Borrador",
        submitted: "Enviado",
        approved: "Aprobado",
        rejected: "Rechazado",
      },
      kind: {
        attendance: "Asistencia",
        break: "Pausa",
        vacation: "Vacaciones",
        sick: "Enfermedad",
        military: "Servicio militar",
        accident: "Accidente",
        compensation_leave: "Permiso compensatorio",
        unpaid_leave: "Permiso no remunerado",
        other_absence: "Otra ausencia",
      },
      workflow: {
        worked: "Trabajado",
        previousWeek: "Semana anterior",
        nextWeek: "Semana siguiente",
        clockState: "Estado del fichaje",
        clockedIn: "Entrada fichada",
        clockedOut: "Salida fichada",
        todaySummary: "Resumen de hoy",
        weekNotCurrent:
          "Selecciona la semana actual para usar el fichaje en directo.",
        break: "Pausa",
        paidBreak: "Pausa pagada",
        unpaidBreak: "Pausa no pagada",
        absence: "Ausencia",
        remaining: "Tiempo restante",
        details: "Detalles",
        actions: "Acciones",
        noEntries: "No hay registros de asistencia o ausencias.",
        noAllocations: "No hay asignaciones de proyectos.",
        noNotes: "Sin notas",
        editEntry: "Editar registro de tiempo",
        newEntry: "Nuevo registro de tiempo",
        allocateTitle: "Asignar tiempo de trabajo",
        searchProjects: "Buscar proyectos elegibles",
        remainingByDay: "Tiempo restante por día",
        allocateRemaining: "Asignar el resto de hoy",
        allocateRemainingWeek: "Asignar el resto de la semana",
        breaksPaidNotice:
          "Las pausas son pagadas y no reducen el tiempo trabajado.",
        issueCount: "{{count}} problemas",
        noIssues:
          "No hay elementos incompletos. La semana está lista para enviar.",
        approval: {
          draft: "Borrador — no enviado",
          submitted: "Enviado para aprobación",
          approved: "Aprobado",
          rejected: "Rechazado — corrige y vuelve a enviar",
        },
        issue: {
          open_stamp: "Ficha la salida antes de enviar.",
          missing_day: "No hay trabajo ni ausencia registrados.",
          allocation_mismatch:
            "Asigna todo el tiempo trabajado ({{worked}} minutos trabajados, {{allocated}} asignados).",
          vacation_overdrawn: "Las vacaciones superan el saldo disponible.",
          unknown: "Completa la información de tiempo requerida.",
        },
        errors: {
          generic: "No se pudo guardar el cambio de tiempo.",
          conflict: "La hoja de horas cambió. Recarga la semana.",
          forbidden: "No puedes modificar esta información de tiempo.",
          validation:
            "Revisa los campos de tiempo y corrige los valores no válidos.",
        },
        breakPresetMorning: "Pausa de la mañana · 09:00",
        breakPresetLunch: "Pausa del almuerzo · 12:00",
        breakPresetAfternoon: "Pausa de la tarde · 15:00",
      },
      teamManagement: {
        search: "Buscar empleados",
        searchPlaceholder: "Nombre o correo electrónico",
        statusFilter: "Estado de la hoja de horas",
        allStatuses: "Todos los estados",
        previousWeek: "Semana anterior",
        nextWeek: "Semana siguiente",
        holidaySummary: "Festivos de la empresa esta semana",
        paidHoliday: "Pagado",
        unpaidHoliday: "No pagado",
        dayBreakdown: "Desglose diario",
        attendance: "Asistencia",
        breaks: "Pausas",
        netAttendance: "Asistencia neta",
        allocated: "Asignado",
        absences: "Ausencias",
        projects: "Órdenes de trabajo",
        noProjects: "No hay órdenes de trabajo asignadas.",
        noDays: "No hay registros de tiempo para esta semana.",
        noTimesheet: "Sin hoja de horas",
        actions: "Acciones",
        rejectionReason: "Motivo del rechazo",
        rejectDialogTitle: "Rechazar la hoja de horas de {{name}}",
        rejectReasonHint:
          "Explica qué debe corregirse antes de volver a enviarla.",
        rejectReasonRequired: "El motivo del rechazo es obligatorio.",
        empty: "Ningún empleado coincide con estos filtros.",
      },
    },
    payroll: {
      title: "Nóminas",
      actions: "Acciones",
      statements: "Recibos de nómina",
      certificates: "Certificados salariales",
      salarySettings: "Ajustes salariales",
      expenses: "Gastos",
      expensesTitle: "Notas de gastos",
      expensesDescription:
        "Crear, enviar y revisar notas de gastos con justificantes.",
      expensesEmployeeDescription:
        "Envía gastos de viaje, comidas y otros gastos reembolsables.",
      expensesManagementDescription:
        "Revisa solicitudes, aprueba reembolsos y consulta los pagos.",
      openExpenses: "Abrir gastos",
      noStatements: "Aún no hay recibos de nómina.",
      noCertificates: "Aún no hay certificados salariales.",
      grossIncome: "Ingresos brutos",
      netIncome: "Ingresos netos",
      downloadPdf: "Descargar PDF",
      downloadXml: "Descargar XML",
      downloadReceipt: "Descargar justificante de envío",
      retrySubmission: "Reintentar envío",
      submissionStatus: {
        configuration_required: "Se requiere configurar el conector",
        pending: "Envío en cola",
        submitting: "Enviando",
        processing: "Procesando por la autoridad",
        completed: "Enviado correctamente",
        failed: "Error de envío",
      },
      status: {
        draft: "Borrador",
        final: "Final",
      },
      salaryType: "Tipo de salario",
      monthly: "Mensual",
      hourly: "Por hora",
      salaryAmount: "Importe salarial",
      salaryBasis: "El importe mensual representa",
      effectivePensum: "La jornada efectiva",
      fullTime: "El salario al 100 %",
      thirteenth: "13.ª paga activada",
      newStatement: "Nuevo recibo de nómina",
      period: "Periodo",
      gross: "Bruto",
      deductions: "Deducciones",
      net: "Neto",
      statementEditor: "Recibo de nómina",
      loadSuggestions: "Cargar propuestas de salario y deducciones",
      earning: "Devengo",
      deduction: "Deducción",
      employerContribution: "Aportación empresarial",
      information: "Información",
      reimbursement: "Reembolso",
      addLine: "Añadir línea",
      code: "Código",
      label: "Etiqueta",
      kind: "Tipo",
      amount: "Importe",
      lineLabels: {
        BASIC: "Salario base",
        AHV: "AVS / AI / APG (5,3 %)",
        ALV: "Seguro de desempleo (1,1 %)",
        NBUV: "Seguro de accidentes no profesionales",
        BVG: "Previsión profesional (LPP)",
        KTG: "Seguro de subsidio diario por enfermedad",
        SOURCE_TAX: "Retención fiscal",
        HOURLY: "Salario por hora",
        "13TH": "13.ª paga",
        REIMBURSEMENT: "Reembolso de gastos",
      },
      finalize: "Finalizar PDF y XML",
      finalizeConfirm:
        "¿Finalizar este recibo? Será inmutable y se creará un PDF.",
      newCertificate: "Nuevo certificado salarial",
      certificateEditor: "Certificado salarial suizo",
      loadAnnualTotals: "Cargar totales anuales finalizados",
      freeTransport: "Transporte gratuito",
      canteen: "Comedor / cheques de comida",
      otherFringeBenefits: "14 Otras prestaciones accesorias",
      remarks: "15 Observaciones",
      certificateFinalizeConfirm:
        "¿Finalizar este certificado? El PDF y XML eLohn serán inmutables.",
      certificate: {
        salary: "1 Salario / pensión",
        foodLodging: "2.1 Comida y alojamiento",
        privateCar: "2.2 Uso privado del vehículo de empresa",
        otherFringeAmount: "2.3 Otras prestaciones accesorias",
        sporadicAmount: "3 Prestaciones irregulares",
        capitalAmount: "4 Prestaciones de capital",
        participationRights: "5 Derechos de participación",
        boardCompensation: "6 Retribución del consejo",
        otherBenefitsAmount: "7 Otras prestaciones",
        socialContributions: "9 Cotizaciones sociales",
        pensionRegular: "10.1 Previsión profesional",
        pensionPurchase: "10.2 Compra de previsión",
        withholdingTax: "12 Retención fiscal",
        travelExpenses: "13.1.1 Gastos de viaje y comida",
        otherEffectiveAmount: "13.1.2 Otros gastos efectivos",
        representationExpenses: "13.2.1 Gastos de representación",
        carExpenses: "13.2.2 Gastos de automóvil",
        otherLumpAmount: "13.2.3 Otros gastos a tanto alzado",
        educationContributions: "13.3 Contribuciones a formación",
        otherFringeDescription: "Descripción prestación accesoria",
        sporadicDescription: "Descripción prestación irregular",
        capitalDescription: "Descripción prestación de capital",
        otherBenefitsDescription: "Descripción otra prestación",
        otherEffectiveDescription: "Descripción otros gastos efectivos",
        otherLumpDescription: "Descripción otros gastos a tanto alzado",
      },
    },
  },
} as const;
